import { useMutation, useQueryClient } from '@tanstack/react-query';
import { detachPaymentMethod } from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function useDetachPaymentMethod() {
  const getToken = useAccountGetToken();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (paymentMethodId: string) =>
      detachPaymentMethod(getToken, paymentMethodId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['account', 'paymentMethods'] });
    }
  });
}
